import axios from 'axios';

import { Bindings } from './Bindings';
import { Customers } from './Customers';
import { Gateways } from './Gateways';
import { GatewaysFiles } from './GatewaysFiles';
import { Screens } from './Screens';
import { Templates } from './Templates';
import { Users } from './Users';
import { WorkshopSchedules } from './WorkshopSchedules';
import { RealEstateListing } from './RealEstateListing';

export class Client {
    token = '';
    http = axios.create({
        baseURL: process.env.VUE_APP_API_URL + '/monitoring-bff/v1'
    });

    gateways = new Gateways(this);
    gatewaysFiles = new GatewaysFiles(this);
    customers = new Customers(this);
    bindings = new Bindings(this);
    templates = new Templates(this);
    users = new Users(this);
    screens = new Screens(this);
    workshopSchedules = new WorkshopSchedules(this);
    realEstateListing = new RealEstateListing();

    constructor() {
        this.http.interceptors.request.use((config) => {
            if (!config.headers) config.headers = {}
            if (this.token) {
                config.headers.authorization = `Bearer ${this.token.accessToken}`;
            }
            return config;
        });
    }

    setToken(token) {
        this.token = token;
    }
}